import "lazysizes"

export default {
  init: function () {
    this.applyLazysizes()
  },

  applyLazysizes: function () {
    const lazyImages = document.querySelectorAll('.lazyload')

    if (!lazyImages) return

    lazySizes.init()
  },
}
